import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-txt",
  "use": "icon-txt-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-txt\"><path d=\"M160 0h512l256 256v704c0 35.3472-28.6528 64-64 64H160c-35.3472 0-64-28.6528-64-64V64c0-35.3472 28.6528-64 64-64z\" fill=\"#8289AD\" p-id=\"1072\" /><path d=\"M536.9088 768V422.1824H672V384H358.4v38.1824h135.0912V768z\" fill=\"#FFFFFF\" p-id=\"1073\" /><path d=\"M672 0l256 256h-192c-35.3472 0-64-28.6528-64-64V0z\" fill=\"#CDCFDE\" p-id=\"1074\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol